<div class="lum-c-dumb-filters">
  <ng-container *ngIf="activeFilters.length > 0; else whenNoFilters">
    <button
      type="button"
      class="lum-button lum-button--link my-1 lum-c-dumb-filters__clear"
      (click)="handleClearFilters($event)"
    >
      <i class="fas fa-times"></i>
      Clear All
    </button>

    <mat-divider
      [vertical]="true"
      class="lum-c-dumb-filters__vrule mr-2"
    ></mat-divider>

    <div class="lum-c-dumb-filters__filters">
      <lum-dumb-filter
        *ngFor="let filter of activeFilters; index as i"
        class="lum-c-dumb-filters__filter"
        [filter]="filter"
        [index]="i"
        (edit)="handleFilterEdit($event)"
        (remove)="handleFilterRemove($event)"
      ></lum-dumb-filter>
    </div>
  </ng-container>
  <ng-template #whenNoFilters>
    <small class="text-muted mr-2"><em>No filters applied</em></small>
  </ng-template>

  <button
    type="button"
    class="lum-button lum-button--link my-1"
    (click)="handleAddFilter($event)"
  >
    <i class="fas fa-plus fa-sm"></i>
    Add Filter
  </button>
</div>
